import { createEffect } from "solid-js";
import { usePostHog } from "@/hooks/usePostHog";
import { useAuthV2 } from "../context/auth-provider";

export function PostHogIdentifier() {
  const { identify, isAlreadyIdentified } = usePostHog();
  const [authStore] = useAuthV2();

  createEffect(() => {
    const profile = authStore.profile;
    if (profile?.id && !isAlreadyIdentified(profile.id)) {
      identify(profile.id, {
        onboarding_status: profile.onboarding_status,
        email: profile.email,
        name: profile.full_name,
        has_resume: !!profile.assets && profile.assets.length > 0,
      });
    }
  });

  return null;
}
